import React, { useState } from 'react';
import styles from '../pages/UserDetailsPage.module.css';
import { updateSupportTicket, deleteSupportTicket } from '../utils/api';

const supportStatusOptions = ['Open', 'In Progress', 'Resolved', 'Closed'];

const SupportTickets = ({ supportTickets, setSupportTickets, onImageClick }) => {
    const [editingTicket, setEditingTicket] = useState(null);
    const [editedTicketData, setEditedTicketData] = useState({});

    const handleEditSupportTicket = (ticket) => {
        setEditingTicket(ticket._id);
        setEditedTicketData({
            status: ticket.status,
            adminResponse: ticket.adminResponse || ''
        });
    };

    const handleEditedTicketChange = (e) => {
        const { name, value } = e.target;
        setEditedTicketData(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveSupportTicket = async (ticketId) => {
        try {
            const res = await updateSupportTicket(ticketId, editedTicketData);
            setSupportTickets(supportTickets.map(t => t._id === ticketId ? res.data : t));
            setEditingTicket(null);
            setEditedTicketData({});
            alert('Support ticket updated successfully!');
        } catch (err) {
            console.error('Failed to update ticket', err);
            alert('Failed to update ticket');
        }
    };

    const handleDeleteSupportTicket = async (ticketId) => {
        if (window.confirm('Are you sure you want to delete this support ticket?')) {
            try {
                await deleteSupportTicket(ticketId);
                setSupportTickets(supportTickets.filter(t => t._id !== ticketId));
                alert('Ticket deleted successfully!');
            } catch (err) {
                console.error('Failed to delete ticket', err);
                alert('Failed to delete ticket');
            }
        }
    };

    return (
        <div className={styles['transactions-list']}>
            {supportTickets.length === 0 ? (
                <p>No support tickets found for this user.</p>
            ) : (
                supportTickets.map(ticket => (
                    <div key={ticket._id} className={styles['transaction-card']}>
                        {editingTicket === ticket._id ? (
                            <div className={styles['edit-transaction-form']}>
                                <div className={styles['form-group']}>
                                    <label>Subject:</label>
                                    <p>{ticket.subject}</p>
                                </div>
                                <div className={styles['form-group']}>
                                    <label>Message:</label>
                                    <p>{ticket.message}</p>
                                </div>
                                <div className={styles['form-group']}>
                                    <label>Status:</label>
                                    <select
                                        name="status"
                                        value={editedTicketData.status || ''}
                                        onChange={handleEditedTicketChange}
                                    >
                                        {supportStatusOptions.map(status => (
                                            <option key={status} value={status}>{status}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className={styles['form-group']}>
                                    <label>Admin Response:</label>
                                    <textarea 
                                        name="adminResponse" 
                                        value={editedTicketData.adminResponse || ''} 
                                        onChange={handleEditedTicketChange}
                                        placeholder="Write your response here..."
                                    />
                                </div>
                                <div className={styles['transaction-card-actions']}>
                                    <button className={styles['btn-approve']} onClick={() => handleSaveSupportTicket(ticket._id)}>Save</button>
                                    <button className={styles['delete-button']} onClick={() => setEditingTicket(null)}>Cancel</button>
                                </div>
                            </div>
                        ) : (
                            <>
                                <h3>{ticket.subject}</h3>
                                <div className={styles['info-group']}>
                                    <span className={styles['info-label']}>Status:</span>
                                    <span className={styles[`status-${ticket.status.toLowerCase().replace(' ', '')}`]}>{ticket.status}</span>
                                </div>
                                <div className={styles['info-group']}>
                                    <span className={styles['info-label']}>Message:</span>
                                    <span>{ticket.message}</span>
                                </div>
                                {ticket.screenshot && (
                                    <div className={styles['info-group']}>
                                        <span className={styles['info-label']}>Screenshot:</span>
                                        <img
                                            src={ticket.screenshot}
                                            alt="Support Screenshot"
                                            style={{ width: '100px', height: '100px', objectFit: 'cover', cursor: 'pointer' }}
                                            onClick={() => onImageClick(ticket.screenshot)}
                                        />
                                    </div>
                                )}
                                <div className={styles['info-group']}>
                                    <span className={styles['info-label']}>Admin Response:</span>
                                    <span>{ticket.adminResponse || 'No response yet'}</span>
                                </div>
                                <div className={styles['info-group']}>
                                    <span className={styles['info-label']}>Time:</span>
                                    <span>{new Date(ticket.createdAt).toLocaleString()}</span>
                                </div>
                                <div className={styles['transaction-card-actions']}>
                                    <button className={styles['btn-approve']} onClick={() => handleEditSupportTicket(ticket)}>Respond / Edit</button>
                                    <button className={styles['delete-button']} onClick={() => handleDeleteSupportTicket(ticket._id)}>Delete</button>
                                </div>
                            </>
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default SupportTickets;
